export class CustomElementsUtil {
    static defineCustomElement(tagName, elementClass) {
        if (!customElements.get(tagName)) {
            customElements.define(tagName, elementClass);
        }
    }
    static isCustomElementDefined(tagName) {
        return customElements.get(tagName) !== undefined;
    }
    /**
     * Queries nodes in the shadow root of an element.
     *
     * @param rootNode - The root element from which to start the query.
     * @param targetSelector - The CSS selector for the target nodes to query.
     * @param customElementSelector - The CSS selector for the custom elements to include in the query.
     *  Defaults to '[beacon-version]' as this initially is used for beacon components, but any custom element can be queried.
     * @param nodeList - An optional array to store the queried nodes. Defaults to an empty array.
     */
    static queryNodesinShadowRoot(rootNode, targetSelector, customElementSelector = '[beacon-version]', nodeList = []) {
        const customElementNodes = Array.from(rootNode.querySelectorAll(customElementSelector));
        customElementNodes.forEach(function addTargetElements(customElement) {
            if (customElement.shadowRoot) {
                const targetNodes = Array.from(customElement.shadowRoot.querySelectorAll(targetSelector));
                targetNodes.forEach((selectorElement) => {
                    nodeList.push(selectorElement);
                });
                const nestedCustomElementNodes = Array.from(customElement.shadowRoot.querySelectorAll(customElementSelector));
                if (nestedCustomElementNodes.length) {
                    nestedCustomElementNodes.forEach((customElementNode) => {
                        addTargetElements(customElementNode);
                    });
                    return;
                }
            }
        });
    }
}
export default CustomElementsUtil;
//# sourceMappingURL=custom-elements-util.js.map